import {
  CANCEL_SUBSCRIPTION_FAILURE,
  CANCEL_SUBSCRIPTION_REQUEST,
  CANCEL_SUBSCRIPTION_SUCCESS,
  FETCH_ACTIVE_SUBSCRIPTION_PLAN_FAILURE,
  FETCH_ACTIVE_SUBSCRIPTION_PLAN_REQUEST,
  FETCH_ACTIVE_SUBSCRIPTION_PLAN_SUCCESS,
  FETCH_SUBSCRIPTION_PLANS_FAILURE,
  FETCH_SUBSCRIPTION_PLANS_REQUEST,
  FETCH_SUBSCRIPTION_PLANS_SUCCESS,
  UNDO_CANCEL_SUBSCRIPTION_FAILURE,
  UNDO_CANCEL_SUBSCRIPTION_REQUEST,
  UNDO_CANCEL_SUBSCRIPTION_SUCCESS,
} from "../actions/action.types";

const initialState = {
  subscriptionPlans: [],
  activeSubscription: {},
  cancelSubscription: {},
  undoCancellation: {},
  loading: false,
  error: null,
};

const subscriptionReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_SUBSCRIPTION_PLANS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_SUBSCRIPTION_PLANS_SUCCESS:
      const { subscriptionPlans } = payload;
      return {
        ...state,
        loading: false,
        subscriptionPlans,
      };
    case FETCH_SUBSCRIPTION_PLANS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
        subscriptionPlans: null,
      };
    case FETCH_ACTIVE_SUBSCRIPTION_PLAN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ACTIVE_SUBSCRIPTION_PLAN_SUCCESS:
      const { activeSubscription } = payload;
      console.log("activeSubscription", activeSubscription);
      return {
        ...state,
        loading: false,
        activeSubscription,
      };
    case FETCH_ACTIVE_SUBSCRIPTION_PLAN_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
        activeSubscription: null,
      };
    case CANCEL_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case CANCEL_SUBSCRIPTION_SUCCESS:
      const { cancelSubscription } = payload;
      return {
        ...state,
        loading: false,
        cancelSubscription,
      };
    case CANCEL_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
        cancelSubscriptions: null,
      };
    case UNDO_CANCEL_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case UNDO_CANCEL_SUBSCRIPTION_SUCCESS:
      const { undoCancellation } = payload;
      return {
        ...state,
        loading: false,
        undoCancellation,
      };
    case UNDO_CANCEL_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};

export default subscriptionReducer;
